import { useCallback, useEffect, useState } from "react"


/**
 * Manages editor state
 */
export const useEditorState = (databaseState) => {

    const [state, setState] = useState({
        value: databaseState,
        dirty: false
    });

    useEffect(() => {
        if(!state.dirty && state.value != databaseState){
            setState( s => ({ ...s, value: databaseState }));
        }
    }, [state.dirty, databaseState]);

    const updateValue = useCallback( v => setState({ dirty: true, value: v }), [])
    const resetDirty = useCallback( () => setState( s => ({ ...s,  dirty: false })), [])

    return [
        state.value, 
        state.dirty, 
        updateValue, 
        resetDirty
    ]
}